/* BF gift + VIP code campaigns (settings "Black Friday free gift", sections/ajax-cart.liquid).
 * c.windows: one entry per campaign {active, start, end, vip, gifts:[{variantId, productId, title, ok}],
 * threshold, name, msgProgress/Added/Gone, codes, ship, vipMsg, vipNext} (no windows: c is the one).
 * vip !== false + VIP key set: only for shoppers who opened a ?vip=<key> link (45 days).
 * vip:false code windows (public sales pub1/pub2): codes managed for every shopper. */
(function (g) {
  'use strict';
  var SKIP = /^(custom order|add-on)$/i, KEY = 'bfGiftDismissed', VIPK = 'bfGiftVip', VIPMS = 45 * 864e5;

  // gift products of a window (or old shape: variantId/productId on the window)
  function gs(w) { return !w ? [] : w.gifts || (w.variantId || w.productId ? [{ variantId: w.variantId, productId: w.productId, title: w.name }] : []); }
  function isOne(it, x) { return +it.variant_id === +x.variantId || (!!x.productId && +it.product_id === +x.productId); }
  function isGift(it, c) { // any window's gift product
    return gs(c).concat.apply(gs(c), (c.windows || []).map(gs)).some(function (x) { return isOne(it, x); });
  }
  function items(cart) { return (cart && cart.items) || []; }
  function dcs(cart) { return (cart && cart.discount_codes) || []; }
  function retail(cart, c) {
    var s = 0;
    items(cart).forEach(function (it) {
      if (isGift(it, c) || SKIP.test(String(it.product_type || '').trim())) return;
      // owner 2026-10-22: tiers and gift use the price before any discount
      s += +(it.original_line_price != null ? it.original_line_price : (it.final_line_price != null ? it.final_line_price : it.line_price)) || 0;
    });
    return s;
  }
  // owner 2026-11-04: the gift counts the cart after discounts, like free shipping. First pass (tier code
  // not on the cart yet): the VIP tier it is about to get is taken off, so the gift is not added then pulled.
  function giftBase(cart, c, w, o) {
    var s = 0, r = retail(cart, c), best = null, dead = o.dead || {}, sub = +(cart && cart.items_subtotal_price) || 0, tot = +(cart && cart.total_price);
    items(cart).forEach(function (it) {
      if (isGift(it, c) || SKIP.test(String(it.product_type || '').trim())) return;
      s += +(it.final_line_price != null ? it.final_line_price : it.line_price) || 0;
    });
    if (sub > 0 && tot >= 0 && tot < sub) s = Math.round(s * tot / sub); // order-level discounts
    if (w && w.vip !== false && o.vip !== false && c.vipKey) (w.codes || []).forEach(function (k) {
      if (k.pct && !dead[lc(k.code)] && r > 0 && r >= k.min && (!best || k.min > best.min)) best = k;
    });
    if (best) s = Math.min(s, Math.round(r * (100 - best.pct) / 100));
    return s;
  }
  function tierOf(w, s) { return (w.codes || []).filter(function (k) { return s && lc(k.code) === lc(s); })[0]; }
  // The campaign live now (no c.windows: c itself is the one campaign).
  function pick(c, now, gift) { return (c.windows || [c]).filter(function (w) { return live(w, now) && (!gift || gs(w).length); })[0] || null; }
  // Code change: null or { send: 'THEIRS,TIER[,SHIP]' | '', want, w, ship }. dead: refused this page.
  // The shipping code rides along with the tier as one unit; its applicable:false (pickup) is no refusal.
  function disc(cart, c, o) {
    var dead = o.dead, w = pick(c, o.now || Date.now()), mine = [], other = [], win = 0, best = null, r, sh, want;
    if (!w || !(w.codes || []).length || (w.vip !== false && !(c.vipKey && o.vip))) return null; // vip:false = public sale
    r = retail(cart, c);
    sh = w.ship && !dead[lc(w.ship)] ? w.ship : '';
    dcs(cart).forEach(function (d) {
      var k = lc(d.code), t = tierOf(w, k);
      // not applicable counts as refused only when the cart meets the minimum (a shrunk cart is no refusal)
      if (t) { mine.push(k); if (d.applicable === false && r > 0 && r >= t.min) dead[k] = 1; }
      else if (k && k === lc(w.ship)) mine.push(k);
      else if (k) { other.push(d.code); if (d.applicable !== false) win = 1; }
    });
    if (win && mine.some(function (k) { return dead[k]; })) w.codes.forEach(function (k) { dead[lc(k.code)] = 1; }); // theirs won
    if (r > 0) w.codes.forEach(function (k) { if (!dead[lc(k.code)] && r >= k.min && (!best || k.min > best.min)) best = k; });
    want = best ? [best.code].concat(sh ? [sh] : []) : [];
    if (mine.length === want.length && want.every(function (x) { return mine.indexOf(lc(x)) > -1; })) return null;
    return { send: other.concat(want).join(','), want: best ? lc(best.code) : '', w: w, ship: best && sh };
  }
  // VIP line of campaign w: vipMsg {pct}, {ship} (w.shipText, added before {next} if absent), {next}
  function vipText(cart, c, dead, w) {
    w = w || c;
    var on = null, nx = null, r = retail(cart, c);
    dcs(cart).forEach(function (d) {
      var k = d.applicable !== false && tierOf(w, d.code);
      if (k && (!on || k.min > on.min)) on = k;
    });
    if (!(on && on.pct)) return '';
    w.codes.forEach(function (k) { if (k.min > on.min && k.min > r && k.pct && !dead[lc(k.code)] && (!nx || k.min < nx.min)) nx = k; });
    var m = String(w.vipMsg || (w.vip === false ? '{title}: {pct}% off applied{next}' : w.ship && !w.shipText ? 'VIP early access: {pct}% off + free shipping applied' : 'VIP {pct}% off applied{next}'));
    if (w.shipText && m.indexOf('{ship}') < 0) m = m.indexOf('{next}') < 0 ? m + '{ship}' : m.replace('{next}', '{ship}{next}');
    return m.split('{ship}').join(w.shipText || '').split('{title}').join(w.title || '').split('{pct}').join(on.pct).split('{next}').join(nx && w.vipNext ? ' \u00b7 ' +
      String(w.vipNext).split('{amount}').join(money(nx.min - r, c.moneyFormat)).split('{nextpct}').join(nx.pct) : '');
  }
  function live(c, now) {
    var a = Date.parse(c.start), b = Date.parse(c.end);
    return !!c.active && (isNaN(a) || isNaN(b) || (now >= a && now < b));
  }
  // Live gift window w: each of its gift products at qty 1 while retail >= threshold (and > 0);
  // every other gift line (any window) goes. o.gone: variant ids out of stock this page.
  function plan(cart, c, o) {
    o = o || {};
    var w = pick(c, o.now || Date.now(), 1), r = w ? giftBase(cart, c, w, o) : retail(cart, c), t = w ? +w.threshold || 0 : 0, gone = o.gone || {}, u = {}, n = 0, seen = {}, ids = [];
    var ok = !!w && r > 0 && r >= t && (w.vip === false || o.vip !== false); // non-VIP: stray gift removed
    var all = gs(w), av = all.filter(function (x) { return x.ok !== false && !gone[+x.variantId]; }), mine = ok ? all : [];
    items(cart).forEach(function (it) {
      if (!isGift(it, c)) return;
      var x = mine.filter(function (y) { return isOne(it, y); })[0], q = x && !seen[x.variantId] ? 1 : 0;
      if (x) seen[x.variantId] = 1;
      ids.push(+it.product_id);
      if (it.quantity !== q) { u[it.key] = q; n++; }
    });
    var miss = av.filter(function (x) { return x.variantId && !seen[x.variantId]; }), add = ok && !o.dismissed && !o.noAdd ? miss : [];
    return { w: w, retail: r, eligible: ok, has: !!ids.length, ids: ids, full: !miss.length, gone: ok && !av.length && !!all.length,
      name: av.length && av.length < all.length ? av.map(function (x) { return String(x.title || '').replace(/^free gift:\s*/i, ''); }).join(' + ') : (w || c).name,
      updates: n ? u : null, remaining: Math.max(0, t - r), pct: t ? Math.min(100, Math.floor(r * 100 / t)) : r > 0 ? 100 : 0,
      add: !!add.length, adds: add.map(function (x) { return +x.variantId; }) };
  }
  // A gift product gone while the cart still qualifies: customer removed it.
  function dismissedBy(prev, next, c, now, vip) {
    var n = plan(next, c, { now: now, vip: vip });
    return n.eligible && plan(prev, c, { now: now, vip: vip }).ids.some(function (id) { return n.ids.indexOf(id) < 0; });
  }
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2).split('.'), i = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return String(fmt || '${{amount}}').replace(/<[^>]*>/g, '').replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      var cm = /comma/.test(k), j = cm ? i.replace(/,/g, '.') : i;
      return /no_dec/.test(k) ? j : j + (cm ? ',' : '.') + v[1];
    });
  }
  function text(p, c) {
    var w = p.w || c;
    return String((p.gone ? w.msgGone : p.has && p.full && p.eligible ? w.msgAdded : w.msgProgress) || '').split('{amount}').join(money(p.remaining, c.moneyFormat)).split('{gift}').join(p.name || '');
  }
  function lc(s) { return String(s || '').toLowerCase(); }
  function vipParam(search) {
    var m = /[?&]vip=([^&#]*)/i.exec(search || '');
    if (!m) return null;
    try { return decodeURIComponent(m[1].replace(/\+/g, ' ')); } catch (e) { return m[1]; }
  }
  // url minus its vip param (rest + hash kept)
  function stripVip(url) {
    var h = '', i = url.indexOf('#'), q;
    if (i > -1) { h = url.slice(i); url = url.slice(0, i); }
    q = url.indexOf('?');
    if (q < 0) return url + h;
    var kept = url.slice(q + 1).split('&').filter(function (kv) { return kv && !/^vip(=|$)/i.test(kv); });
    return url.slice(0, q) + (kept.length ? '?' + kept.join('&') : '') + h;
  }
  function isVip(c, rec, now) {
    if (!c.vipKey) return true;
    return !!rec && lc(rec.key) === lc(c.vipKey) && now - (+rec.at) <= VIPMS;
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { retail: retail, plan: plan, dismissedBy: dismissedBy, money: money, text: text, KEY: KEY,
      VIPK: VIPK, vipParam: vipParam, stripVip: stripVip, isVip: isVip, disc: disc, vipText: vipText, pick: pick, isGift: isGift };
    return;
  }
  if (!g.fetch) return;
  var d = g.document, c;
  try { c = JSON.parse(d.getElementById('bfGiftConfig').textContent); } catch (e) { return; }
  var root = (g.Shopify && g.Shopify.routes && g.Shopify.routes.root) || '/';
  var raw = g.fetch, last = null, busy = false, again = false, timer = 0, adds = 0, self = false, dead = {}, dn = 0, gone = {};

  // VIP link: store a matching ?vip=<key>, strip it from the URL.
  if (c.vipKey && (c.active || pick(c, Date.now()))) {
    try {
      var vk = vipParam(g.location.search);
      if (vk != null && lc(vk) === lc(c.vipKey)) {
        localStorage.setItem(VIPK, JSON.stringify({ key: vk, at: Date.now() }));
        if (g.history && g.history.replaceState) g.history.replaceState(g.history.state, '', stripVip(g.location.href));
      }
    } catch (e) {}
  }
  function vip() {
    var rec = null;
    try { rec = JSON.parse(localStorage.getItem(VIPK)); } catch (e) {}
    return isVip(c, rec, Date.now());
  }

  function ss(v) {
    try { if (v) sessionStorage.setItem(KEY, '1'); return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }
  function req(path, body) {
    var o = { credentials: 'same-origin' };
    if (body) { o.method = 'POST'; o.headers = { 'Content-Type': 'application/json' }; o.body = JSON.stringify(body); }
    return raw.call(g, root + path, o).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function sections() {
    var out = [];
    ['ajaxCartContent', 'ajaxCartBtn', 'cartContent'].forEach(function (id) {
      var n = d.getElementById(id), s = n && n.closest('.shopify-section'), k = s && s.id.replace('shopify-section-', '');
      if (k && out.indexOf(k) < 0) out.push(k);
    });
    return out;
  }
  function redraw(r) { if (r && r.sections && g.EventBus) g.EventBus.emit('cart:updated', { sections: r.sections }); }
  // owner 2026-11-04: VIP gift window, gift and free shipping both $X away -> one line for both
  // ("You're $X away from free shipping + a free gift!" + the gift detail); the theme's shipping bar hides.
  // Amounts differ (e.g. custom builder lines): both bars as before.
  function merged(p, v, cart) {
    var st = +c.shipThr || 0, sr = st > 0 ? Math.max(0, st - (+(cart && cart.total_price) || 0)) : -1;
    if (!p.w || p.w.vip === false || !v || !st || st !== +p.w.threshold || sr !== p.remaining) return null;
    if (items(cart).some(function (it) { return it.properties && it.properties._design_id; })) return null;
    var mz = function (n) { return money(n, c.moneyFormat).replace(/[.,]00(?=\D*$)/, ''); };
    return p.has && p.eligible ? ['You\u2019ve got free shipping + a free gift!', '', '', 'Your ' + p.name + ' has been added.']
      : ['You\u2019re ', mz(p.remaining), ' away from free shipping + a free gift!', 'Spend ' + mz(st) + ' to get a free ' + p.name + '.'];
  }
  function setMerged(t, m) {
    var key = m.join('|');
    if (t.getAttribute('data-bf-m') === key) return;
    t.setAttribute('data-bf-m', key);
    t.textContent = '';
    t.appendChild(d.createTextNode(m[0]));
    if (m[1]) { var b = d.createElement('strong'); b.textContent = m[1]; t.appendChild(b); }
    if (m[2]) t.appendChild(d.createTextNode(m[2]));
    var sp = d.createElement('span'); sp.className = 'bf-gift__sub'; sp.textContent = m[3]; t.appendChild(sp);
  }
  function paint(p, v, cart) { // non-VIP: bar stays hidden
    var cw = pick(c, Date.now()), s = text(p, c), w = (p.has && p.eligible ? 100 : p.pct) + '%';
    var gift = p.w && (p.w.vip === false || v) && !(p.eligible && !p.full), x = cw && (cw.vip === false || v && c.vipKey) ? vipText(cart, c, dead, cw) : '';
    var mg = gift ? merged(p, v, cart) : null;
    Array.prototype.forEach.call(d.querySelectorAll('[data-bf-gift-bar]'), function (b) {
      var q = function (n) { return b.querySelector('.bf-gift__' + n); }, t = q('text'), f = q('fill'), k = q('track'), y = q('vip');
      var sec = b.closest && b.closest('.shopify-section');
      if (sec) sec.classList.toggle('bf-ship-merged', !!mg);
      b.hidden = !gift && !x;
      if (t) {
        t.hidden = !gift;
        if (mg) setMerged(t, mg);
        else if (t.hasAttribute('data-bf-m') || t.textContent !== s) { t.removeAttribute('data-bf-m'); t.textContent = s; }
      }
      if (k) k.hidden = !gift;
      if (f) f.style.width = w;
      if (y) { y.hidden = !x; if (y.textContent !== x) y.textContent = x; }
    });
  }
  // Read, fix, re-render.
  function run(o) {
    o = o || {};
    if (busy && !o.force) { again = true; return Promise.resolve(); }
    var mine = !busy; busy = true;
    return req('cart.js').then(function (cart) {
      var v = vip();
      if (last && !self && dismissedBy(last, cart, c, Date.now(), v)) ss(1); // not ours
      self = false;
      last = cart;
      var p = plan(cart, c, { dismissed: ss(), noAdd: o.noAdd || adds > 2, vip: v, gone: gone, dead: dead });
      var k = dn < 6 ? disc(cart, c, { vip: v, dead: dead }) : null, x, b;
      paint(p, v, cart);
      // Lines (update OR add), then one code update; one re-render.
      if (p.updates) { self = true; b = { updates: p.updates }; if (!k) b.sections = sections(); x = req('cart/update.js', b); }
      else if (p.add) { adds++; x = addG(p.adds, !k); }
      return Promise.resolve(x).then(function (r) {
        if (!k) return redraw(r);
        dn++;
        return req('cart/update.js', { discount: k.send, sections: sections() }).then(function (r) {
          var rc = (r || {}).discount_codes && dcs(r).map(function (d) { return d.applicable === false ? '!' + lc(d.code) : lc(d.code); });
          if (rc && k.want && rc.indexOf(k.want) < 0) {
            var kt = tierOf(k.w, k.want), kr = retail(r, c);
            if (kt && kr > 0 && kr >= kt.min) dead[k.want] = 1; // refused at its minimum
          }
          if (rc && k.ship && rc.indexOf(lc(k.ship)) < 0 && rc.indexOf('!' + lc(k.ship)) < 0) dead[lc(k.ship)] = 1; // dropped, not just n/a
          redraw(r);
        });
      });
    }).catch(function () {}).then(function () {
      if (mine) { busy = false; if (again) { again = false; soon(); } }
    });
  }
  // One add for all missing gifts. Refused (sold out) or missing from the reply: gone for this page.
  // A refused multi-item add is retried one item at a time to find which one is out.
  function addG(ids, s) {
    var n = 0, out = function (id) { gone[id] = 1; n++; };
    function one(list) {
      var b = { items: list.map(function (id) { return { id: id, quantity: 1 }; }) };
      if (s) b.sections = sections();
      return req('cart/add.js', b).then(function (r) {
        list.forEach(function (id) { if (!((r && r.items) || []).some(function (it) { return +it.variant_id === id; })) out(id); });
        return r;
      });
    }
    return one(ids).catch(function () {
      var l = null;
      return ids.reduce(function (q, id) {
        return q.then(function () { return ids.length > 1 ? one([id]).then(function (r) { l = r; }, function () { out(id); }) : out(id); });
      }, Promise.resolve()).then(function () { return l; });
    }).then(function (r) { if (n) soon(); return r; }); // repaint with the "claimed" text
  }
  function soon() { clearTimeout(timer); timer = setTimeout(run, 60); }

  // Cart changes: drawer re-render event + fetch to /cart/*.
  if (g.EventBus && g.EventBus.on) g.EventBus.on('cart:markup:updated', soon);
  g.fetch = function (u) {
    var r = raw.apply(g, arguments);
    try { if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String((u && u.url) || u))) r.then(soon, soon); } catch (e) {}
    return r;
  };
  d.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : d.body, a = t.closest('a[href*="/checkout"]');
    if (t.closest('[data-behavior="remove-line"]') && t.closest('[data-bf-gift]')) ss(1);
    if (a) guard(e, function () { g.location.href = a.href; });
  }, true);
  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && /\/checkout/.test(f.getAttribute('action') || '')) guard(e, function () { HTMLFormElement.prototype.submit.call(f); });
  }, true);
  // Checkout with a gift: hold, fix, go on (submit() fires no event).
  function guard(e, go) {
    if (last && !plan(last, c, { gone: gone }).has) return;
    e.preventDefault();
    var done = false, fin = function () { if (!done) { done = true; go(); } };
    setTimeout(fin, 5000);
    run({ noAdd: 1, force: 1 }).then(fin, fin);
  }
  run();
})(this);
